import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { tinNumbers } from "@/constants/invoiceTypes";
import { Button } from "./ui/button";
import { VisuallyHidden } from "radix-ui";
import { DialogDescription } from "@radix-ui/react-dialog";

type TinSearchProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (value: string) => void;
};

const TinSearch = ({ isOpen, onClose, onSelect }: TinSearchProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onInteractOutside={(event) => event.preventDefault()}
        className="max-w-md h-fit px-4 py-10"
      >
        <VisuallyHidden.Root>
          <DialogTitle>TIN Numbers</DialogTitle>
          <DialogDescription>Choose available TIN</DialogDescription>
        </VisuallyHidden.Root>
        <div className="w-full flex flex-col max-h-60 overflow-y-auto">
          {tinNumbers.map((tin, index) => (
            <div
              key={index}
              className={`w-full flex p-2.5 cursor-default justify-between items-center leading-none text-sm hover:bg-slate-100 ${
                index + 1 === tinNumbers.length ? "" : "border-b"
              }`}
            >
              <div className="flex flex-col gap-2">
                <span className="font-semibold">{tin.name}</span>
                <span className="text-gray-600">{tin.value}</span>
              </div>
              <Button
                type="button"
                onClick={() => {
                  onSelect(tin.value);
                  onClose();
                }}
                size="sm"
                variant="outline"
              >
                Select
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TinSearch;
